import React from 'react';
import PropTypes from 'prop-types';

// Components
import WidgetEvent from './WidgetEvent';

// Presentational Component
const WidgetEvents = ({ widget }) => {

	const firstEvent = widget.events[0];
	const preventableEvents = widget.events.filter(ev => ev.isPreventable);
	const firstPreventableEvent = preventableEvents[0];  // Could be undefined if no preventable events
	const responseEvents = widget.events.filter(ev => ev.hasResponse);
	const firstResponseEvent = responseEvents[0];  // Could be undefined if no response events
	const exampleElementId = `#my${widget.name}`;

	return (
		<div className="widget-events">
			<h3 id={`${widget.name}-events`}>Events</h3>
			<p>The {widget.name} widget exposes events for hooking into its functionality.</p>
			<div className='data-table-responsive'>
				<table className="table table-bordered table-striped bs-events-table">
					<thead>
						<tr>
							<th>Event Type</th>
							<th>Description</th>
						</tr>
					</thead>
					<tbody>
						{
							widget.events.map(event => <WidgetEvent key={event.name} event={event} />)
						}
					</tbody>
				</table>
			</div>
			{firstPreventableEvent &&
				<pre className="language-javascript"><code className="language-javascript">{
					`$('${exampleElementId}').on('${firstPreventableEvent.name}'), function (event) {
	if (!validate()) {
		event.preventDefault();
	}
}`}
				</code></pre>
			}
			{firstResponseEvent &&
				<pre className="language-javascript"><code className="language-javascript">{
					`$('${exampleElementId}').on('${firstResponseEvent.name}'), function (event, response) {
	if (response.status === "success") {
		// do something...
	}
}`}
				</code></pre>
			}
			{!firstPreventableEvent && !firstResponseEvent &&
				<pre className="language-javascript"><code className="language-javascript">{
					`$('${exampleElementId}').on('${firstEvent.name}'), function (event) {
	// do something...
}`}
				</code></pre>
			}
		</div>
	);
};

WidgetEvents.propTypes = {
	widget: PropTypes.object.isRequired
};

export default WidgetEvents;















// WEBPACK FOOTER //
// ./src/components/widgets/WidgetEvents.js